import { useEffect, useState } from 'react';
import { GymMinimalProps } from '../constants/types';
import { getRouteSetterGymFilterInfo } from '../data/getAxiosRequests';

interface UseGymSelectionReturn {
    isModalOpen: boolean;
    setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    handleGymSelect: (gym: GymMinimalProps) => void;
}

export function useGymSelection(
    user: string | null,
    setCurrentGym: (gym: GymMinimalProps) => void,
    setGymsFilterInfo: (info: GymMinimalProps[]) => void,
): UseGymSelectionReturn {
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const favoriteGym = localStorage.getItem('favoriteGymInfo');
        if (favoriteGym) {
            setCurrentGym(JSON.parse(favoriteGym));
        } else if (user) {
            getRouteSetterGymFilterInfo(user).then(data => {
                setGymsFilterInfo(data);
                if (data.length > 0) {
                    setIsModalOpen(true);
                }
            });
        } else {
            console.error("user not provided");
        }
    }, [user, setCurrentGym]);

    const handleGymSelect = (gym: GymMinimalProps) => {
        setCurrentGym(gym);
        localStorage.setItem('favoriteGymInfo', JSON.stringify(gym));
        setIsModalOpen(false);
    };

    return { isModalOpen, setIsModalOpen, handleGymSelect };
}
